var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.hidden,
          expression: "!hidden"
        }
      ],
      staticClass: "input grid__cell",
      class: [_vm.inputClasses]
    },
    [
      _c("div", { staticClass: "input--checkbox" }, [
        _c(
          "div",
          { staticClass: "input-top mg mg--b-2" },
          [
            _c("p", { staticClass: "title-input text-small blueDark" }, [
              _vm._v(_vm._s(_vm.$t(_vm.literal)))
            ]),
            _vm.showTooltip
              ? _c("ma-tooltip", { attrs: { textInfo: _vm.textTooltip } })
              : _vm._e()
          ],
          1
        ),
        _c(
          "ul",
          { staticClass: "input__wrapper" },
          _vm._l(_vm.options, function(option) {
            return _c("li", [
              _c("label", [
                _c("p", { staticClass: "text-medium black" }, [
                  _vm._v(_vm._s(_vm.$t(option.literal)))
                ]),
                _c("input", {
                  attrs: { type: "checkbox", for: _vm.name, name: _vm.name },
                  domProps: {
                    value: option.key,
                    checked: _vm.isChecked(option.key)
                  },
                  on: { change: _vm.handleCheckboxClick }
                }),
                _c("span", { staticClass: "checkmark" })
              ])
            ])
          }),
          0
        )
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.alertIsVisible,
              expression: "alertIsVisible"
            }
          ],
          staticClass: "input__alerts"
        },
        [
          _c(
            "div",
            { staticClass: "input__icon" },
            [_c("svgicon", { attrs: { name: "alert-circle" } })],
            1
          ),
          _c("div", { staticClass: "input__alerts__wrapper" }, [
            _c(
              "div",
              _vm._l(_vm.validationErrors, function(error) {
                return _c("p", { staticClass: "input__alerts__text" }, [
                  _vm._v(_vm._s(error.description))
                ])
              }),
              0
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }